import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Box, Button, Dialog, EmptyState } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
export function DialogError(props) {
    const { onClose, onRetry } = props;
    return (<Dialog>
      <EmptyState withAvatar icon={<Falcon icon="circle-exclamation"/>} title={t({
            message: 'Error',
            comment: 'Edit document dialog - Error title',
        })} description={t({
            message: 'Something went wrong, please try again later.',
            comment: 'Edit document dialog - Error description',
        })} actions={<Box gap="md">
            <Button type="button" onClick={onClose} size="small" appearance="secondary">
              <Trans comment="Edit document dialog - Close button label">Close</Trans>
            </Button>
            <Button type="button" onClick={onRetry} size="small" appearance="secondary">
              <Trans comment="Edit document dialog - Retry button label">Retry</Trans>
            </Button>
          </Box>}/>
    </Dialog>);
}
